import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'];

const PartsCostBreakdown = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-card rounded-lg shadow-elevation-1 p-6">
        <div className="flex items-center gap-3 mb-6">
          <Icon name="Package" className="w-5 h-5 text-blue-600" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Desglose de Costos de Refacciones
          </h3>
        </div>
        <div className="flex justify-center items-center h-64">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      </div>
    );
  }

  const { totalPartsCost = 0, byCategory = [] } = data || {};

  const chartData = byCategory?.slice(0, 8)?.map((item, index) => ({
    name: item?.category,
    value: item?.cost,
    fill: COLORS?.[index % COLORS?.length]
  }));

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    })?.format(value);
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="Package" className="w-5 h-5 text-blue-600" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Desglose de Costos de Refacciones
          </h3>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">Total</p>
          <p className="text-2xl font-bold text-blue-600">
            {formatCurrency(totalPartsCost)}
          </p>
        </div>
      </div>

      {byCategory?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
          <Icon name="Package" className="w-12 h-12 mb-3 opacity-50" />
          <p className="text-sm">No hay datos de refacciones disponibles</p>
        </div>
      ) : (
        <>
          <div className="h-64 mb-6">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {chartData?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry?.fill} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value) => formatCurrency(value)}
                  contentStyle={{
                    backgroundColor: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '8px 12px'
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="space-y-2">
            <p className="text-sm font-medium text-muted-foreground mb-3">Top Categorías</p>
            {byCategory?.slice(0, 5)?.map((item, index) => {
              const percentage = totalPartsCost > 0 ? (item?.cost / totalPartsCost) * 100 : 0;
              return (
                <div key={index} className="flex items-center justify-between py-2 border-b border-border last:border-0">
                  <div className="flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: COLORS?.[index % COLORS?.length] }}
                    />
                    <span className="text-sm text-foreground">{item?.category}</span>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-semibold text-foreground">
                      {formatCurrency(item?.cost)}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {percentage?.toFixed(1)}%
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default PartsCostBreakdown;